import app from 'flarum/forum/app';
import addArticlesMenu from './addArticlesMenu';
export { default as extend } from './extend';
app.initializers.add('champis-articles', () => {
  addArticlesMenu();
});